import type { SxProps, Theme } from "@mui/material/styles";

import type { CopyLinkRowSize } from "./CopyLinkRow.types";

const HEIGHT: Record<CopyLinkRowSize, number> = { sm: 44, lg: 56 };

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "stretch",
  gap: theme.spacing(1),
  width: "100%",
  minWidth: 0,
});

export const input =
  (size: CopyLinkRowSize): SxProps<Theme> =>
  (theme) => ({
    flex: 1,
    minWidth: 0,
    "& .MuiOutlinedInput-root": {
      height: HEIGHT[size],
      bgcolor: theme.palette.background.default,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: size === "sm" ? "0.75rem" : "0.8125rem",
      color: theme.palette.text.secondary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      py: 0,
    },
  });

export const copyButton =
  (size: CopyLinkRowSize): SxProps<Theme> => ({
    flexShrink: 0,
    whiteSpace: "nowrap",
    minWidth: size === "sm" ? 104 : 120,
    height: HEIGHT[size],
    px: 2,
    py: 0,
    fontSize: size === "sm" ? "0.8125rem" : "0.875rem",
    // sx multiplies by theme.shape.borderRadius, so 1 matches the input (10px).
    borderRadius: 1,
    boxShadow: "none",
    "& .MuiButton-startIcon": { marginInlineStart: 0, marginInlineEnd: 0.75 },
  });
